/*
 * @Author: Tina Huang
 * @Date: 2024-04-23 13:49:32
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 15:30:14
 * @Description:
 */
import { Button, Carousel, Segmented } from 'antd'
import { PopularPicks } from '@/constants/picks'
import styles from './panel.module.css'
import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function PanelTemplate() {
  const isMobile = window.innerWidth <= 750
  const [activeIndex, setActiveIndex] = useState(0)
  const carouselRef = useRef<any>(null)
  const navigate = useNavigate()

  // const activeItem = useMemo(() => {
  //   return PopularPicks[activeIndex]
  // }, [activeIndex])

  const handleHover = (index: number) => {
    if (index !== activeIndex) {
      setActiveIndex(index)
    }
  }

  return (
    <div className="text-center mt-12">
      <div className={styles.detail}>
        <img src={`./assets/panel-2${isMobile ? '_col' : ''}.png`} alt="" />
        <div className={styles.detailNum} onClick={() => navigate('/vips')}>
          <span>VIP 模板</span>
          <div>
            <p className="hidden sm:block">快捷订阅所有模板，开通永久订阅所有模板，「特惠」活动正在进行中，目前已更新 👉</p>
            <h1 className={`${isMobile ? 'text-4xl' : 'text-5xl'} font-bold font-mono`}>60+</h1>
            {isMobile ? <div onClick={() => navigate('/vips')}>立即订阅</div> : <></>}
          </div>
          <section className={styles.subscribeBtn}>
            <div onClick={() => navigate('/vips')}>立即订阅</div>
          </section>
        </div>
        <div className={styles.detailMsg}>
          欢迎来到阿汪同学的小世界，这里将为你解答为什么需要使用模板以及如何使用
          <br />
          Welcome to Wang's world, I will answer why you need to use templates and how to use them
        </div>
      </div>
      <div className={styles.mainTemplate}>
        <div className={styles.tempMenus}>
          {PopularPicks.map((item, index) => (
            <div className={`${index === activeIndex ? styles.active : ''}`} onMouseOver={() => handleHover(index)}>
              {item.icon} {item.title}
            </div>
          ))}
        </div>
        {PopularPicks.map((item, index) => (
          <div className={`${styles.content} ${index === activeIndex ? styles.contentShow : ''}`}>
            {isMobile ? (
              <div onClick={() => navigate(item?.path)}>
                <h1 className="text-3xl font-bold flex items-center justify-center">
                  <span className="text-lg text-white bg-black p-2 rounded-lg mr-2">{item.tag}</span>
                  {item.title}
                </h1>
                <img src={item.cover} className="w-full" alt="" />
              </div>
            ) : (
              <>
                <img src={item.cover} className="w-1/3" alt="" />
                <div className="pt-5 relative">
                  <h1 className="text-5xl font-bold flex items-center">
                    <span className="text-2xl text-white bg-black p-2 rounded-lg mr-3">{item.tag}</span>
                    {item.title}
                  </h1>
                  <ul className="text-xl text-left mt-4 leading-8">
                    {item.desc.map((_d) => (
                      <li>{_d}</li>
                    ))}
                  </ul>
                  <div className={`absolute right-4 bottom-4 opacity-0 ${styles.tempBtn}`}>
                    <span className="text-lg mr-5">{item.btn}</span>
                    <Button type="primary" shape="round" size="large" onClick={() => navigate(item?.path)}>
                      浏览模板
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
      <br />
      <h1 className="text-2xl font-bold underline underline-offset-8 decoration-rose-800">为什么要用模板？</h1>
      <br />
      <p className={`text-lg text-left leading-8 ${isMobile ? 'w-full' : 'w-2/3'} m-auto`}>
        <span className="text-white bg-black p-2 rounded-lg mr-3">什么是Notion模板</span>
        模板是预先构建的Notion页面，可以将其添加到自己的工作区。无需尝试重新构建简单页面或复杂工作流程，只需将Notion模板添加到您的工作区即可开始。模板可以是团队知识库、个人锻炼跟踪器，以及其他各种内容。
      </p>
      <p className={`text-lg text-left leading-8 ${isMobile ? 'w-full' : 'w-2/3'} m-auto`}>
        随着生活和工作需求的增加，使用模板已成为一种便捷的选择，无需花费大量时间研究设计制作相关内容。模板的使用不仅能节省时间，还能帮助我们更深入地了解Notion。
      </p>
      <div className={styles.whyBox}>
        <img className={styles.whyBoxImg} src="./assets/ipad/panel-2/1.png" alt="" />
        <img className={styles.whyBoxImg} src="./assets/ipad/panel-2/2.png" alt="" />
        <img className={styles.whyBoxImg} src="./assets/ipad/panel-2/3.png" alt="" />
      </div>
      <h1 className="text-2xl font-bold underline underline-offset-8 decoration-rose-800">如何导入使用模板？</h1>
      <ul className={styles.stepBox}>
        <Segmented
          className="mb-5"
          options={[
            {
              label: (
                <div className={styles.stepLabel}>
                  <h1 className="text-5xl font-bold">01</h1>
                  <p className="text-xl pt-2">注册登录</p>
                </div>
              ),
              value: 0,
            },
            {
              label: (
                <div className={styles.stepLabel}>
                  <h1 className="text-5xl font-bold">02</h1>
                  <p className="text-xl pt-2">选择模板</p>
                </div>
              ),
              value: 1,
            },
            {
              label: (
                <div className={styles.stepLabel}>
                  <h1 className="text-5xl font-bold">03</h1>
                  <p className="text-xl pt-2">访问模板</p>
                </div>
              ),
              value: 2,
            },
          ]}
          onChange={(v) => carouselRef.current?.goTo(v)}
        />
        <Carousel dots={false} ref={carouselRef} className={`rounded-xl overflow-hidden`}>
          <li>
            <h2>在当前浏览器注册或者登录你的Notion/FlowUs账号</h2>
            <div className={`${styles.stepDetail} flex justify-center`}>
              <div className={`${isMobile ? 'w-full' : 'w-1/3'} p-5 text-center`}>
                <h3>
                  Notion 注册登录
                  <a
                    className="font-weight text-white border p-2 rounded-lg ml-5 text-xl"
                    href="https://www.notion.so/login"
                    target="_blank"
                    rel="noreferrer"
                  >
                    立即登录
                  </a>
                </h3>
                <img className="m-auto" src="./assets/ipad/panel-2/4.png" alt="" />
              </div>
              <div className={`${isMobile ? 'w-full' : 'w-1/3'} p-5 text-center`}>
                <h3>
                  FlowUs 注册登录
                  <a
                    className="font-weight text-white border p-2 rounded-lg ml-5 text-xl"
                    href="https://flowus.cn/login/?code=YJDF4B"
                    target="_blank"
                    rel="noreferrer"
                  >
                    立即登录
                  </a>
                </h3>
                <img className="m-auto" src="./assets/ipad/panel-2/5.png" alt="" />
              </div>
            </div>
          </li>
          <li>
            <h2>在本站浏览选择你需要的模板</h2>
            <div className={styles.stepDetail}>
              <p className="mt-4">在模板页面选择购买或者直接拷贝免费模板</p>
              <img className="m-auto w-4/5" src="./assets/ipad/panel-2/picks.png" alt="" />
            </div>
          </li>
          <li>
            <h2>在当前浏览器打开所选择的模板链接并进行访问</h2>
            <div className={styles.stepDetail}>
              <p className="mt-4">Notion模板请点击右上角的「Duplicate」按钮进行拷贝</p>
              <p>FlowUs模板请点击右上角的「拷贝到」按钮进行拷贝</p>
              <img className="m-auto w-4/5 mt-14" src="./assets/ipad/panel-2/duplicate.png" alt="" />
            </div>
          </li>
        </Carousel>
      </ul>
      {/* <h1 className="text-2xl font-bold underline underline-offset-8 decoration-rose-800">功能介绍</h1> */}
    </div>
  )
}
